import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, Input } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetch } from "../../../../../../fetch/fetch";
import styles from "./staffmanage.module.css";
import { API, toastOptions, errorText } from "./rosterutils";

//신규직원 TODO 연필 — 주민등록번호·은행·계좌번호·예금주 직접 입력/수정 (사람 단위 staffProfiles). 저장하면 "확인 필요" 표시가 해제됨
//직원명부에서는 보기만 하고 여기(신규직원 TODO)에서만 고친다
const ProfileEditModal: React.FC<any> = (props) => {

    const [residentNumber, setResidentNumber] = useState("");
    const [bankName, setBankName] = useState("");
    const [bankAccount, setBankAccount] = useState("");
    const [accountHolder, setAccountHolder] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (props.open) {
            const p = props.initial || {};
            setResidentNumber(p.residentNumber || "");
            setBankName(p.bankName || "");
            setBankAccount(p.bankAccount || "");
            setAccountHolder(p.accountHolder || "");
        }
    }, [props.open, props.initial]);

    //"9001011234567" 처럼 붙여 넣어도 하이픈 자동
    const normalizeRrn = (v: string) => {
        const d = v.replace(/[^0-9]/g, "");
        if (d.length === 13) return `${d.slice(0, 6)}-${d.slice(6)}`;
        return v.trim();
    };

    const save = async () => {
        const rrn = normalizeRrn(residentNumber);
        if (rrn && !/^\d{6}-\d{7}$/.test(rrn)) {
            toast.error("주민등록번호는 000000-0000000 형식이어야 합니다", toastOptions);
            return;
        }
        const acct = bankAccount.trim();
        if (acct && !/^[0-9-]{6,30}$/.test(acct)) {
            toast.error("계좌번호는 숫자와 하이픈만 입력하세요", toastOptions);
            return;
        }
        try {
            setSaving(true);
            const result: any = await postFetch(`${API}/profiles/${props.userId}/fields`, {
                residentNumber: rrn, bankName: bankName.trim(), bankAccount: acct, accountHolder: accountHolder.trim()
            });
            if (result.message === "success") {
                toast.success("저장했습니다", toastOptions);
                if (props.onSaved) props.onSaved();
                props.onClose();
            } else {
                toast.error(result.message === "wrongResidentNumber" ? "주민등록번호 형식이 틀렸습니다" : result.message === "wrongBankAccount" ? "계좌번호 형식이 틀렸습니다" : errorText(result, "저장에 실패했습니다"), toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("오류가 발생했습니다", toastOptions);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog sx={{ width: "440px", maxWidth: "95vw" }}>
                <div className={styles.modalTitle}>{props.userName} · 주민번호 / 계좌 수정</div>

                <div className={styles.fieldLabel}>주민등록번호</div>
                <Input size="sm" value={residentNumber} placeholder="000000-0000000" onChange={(e) => setResidentNumber(e.target.value)} onBlur={() => setResidentNumber(normalizeRrn(residentNumber))} />

                <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ flex: 1 }}>
                        <div className={styles.fieldLabel}>은행</div>
                        <Input size="sm" value={bankName} placeholder="예: 국민은행" onChange={(e) => setBankName(e.target.value)} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <div className={styles.fieldLabel}>예금주</div>
                        <Input size="sm" value={accountHolder} onChange={(e) => setAccountHolder(e.target.value)} />
                    </div>
                </div>

                <div className={styles.fieldLabel}>계좌번호</div>
                <Input size="sm" value={bankAccount} placeholder="숫자와 하이픈" onChange={(e) => setBankAccount(e.target.value)} />

                <div className={styles.modalButtons}>
                    <div className={styles.hint}>비우고 저장하면 그 값이 지워집니다. 저장하면 "확인 필요" 표시가 해제됩니다</div>
                    <div style={{ display: "flex", gap: "8px" }}>
                        <Button variant="plain" color="neutral" onClick={props.onClose} disabled={saving}>닫기</Button>
                        <Button variant="solid" onClick={save} loading={saving}>저장</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default ProfileEditModal;
